// tslint:disable: variable-name

export interface LoginResponseModel {
  RedirectURL: string;
  LoginModel: LoginModel;
  OutputFields: Array<InputField>;
}

export interface LoginModel {
  LoginInputFields: InputField[];
  LoginTypeID: LoginType;
  LoginProviderID: ProviderName;
  RememberMe: boolean;
  IsSingleSignOn: boolean;
  ReturnUrl: string;
}

export interface InputField {
  FieldName: string;
  InputType: InputType;
  Active: boolean;
  Value: string;
  ErrorMessage: string;
}

export enum LoginType {
  Portal = 1,
  Admin = 2,
  External = 3,
  SingleSignOn = 4,
  Social = 5,
}

export enum ProviderName {
  Dummy = 0,
  Fortress = 1,
  TicketMaster = 2,
  Sage = 3,
  SeeTickets = 4,
  Facebook = 5,
  Instagram = 6,
  Google = 7,
  Twitter = 8,
  Pinterest = 9,
  LinkedIn = 10,
  Yahoo = 11,
  Yandex = 12,
  TencentQQ = 13,
  Weibo = 14,
  Youku = 15,
  TDC = 16,
  YesPay = 17,
  PayEx = 18,
  StreamingVideoProvider = 20,
  Lodestone = 23,
  MLBAM = 24,
  OutBox = 25,
  OptBank = 26,
  EPay = 27,
  TNS = 28,
  WhatsApp = 29,
  FourSquare = 30,
  YouTube = 31,
  RoboTicket = 32,
  SportSubs = 33,
  TopTix = 34,
  PayPal = 35,
  Forecast = 36,
  OptimalPayments = 37,
  TicketMasterUK = 38,
  Wirecard = 39,
  Passbook = 40,
  GlobalProcessingService = 41,
  TradableBits = 42,
  CreditGuard = 43,
  Ingenico = 44,
  SidelineSports = 45,
  Awin = 46,
  ThreePAK = 47,
  Stripe = 48,
  FreedomPay = 49,
  Paya = 50,
  Viemo = 51,
  Twitch = 52,
  Zoom = 53,
  Boxcast = 54,
  Streamable = 55,
  Incrowd = 56,
  UrbanZoo = 57,
  SAP = 58,
  TheFirstClub = 59,
  SportsAlliance = 60,
  StreamAMG = 61,
  Rakuten = 62,
  Fidel = 63,
  Partnerize = 64,
  EBay = 65,
  Impact = 66,
  OctopusEnergy = 67,
  TheSupermarketingGroup = 68,
  Optomany = 69,
  SmartPayFuse = 70,
  SQWAD = 71,
  KeyCloak = 72,
  SeatGeek = 73,
  Secutix = 74,
  Tappit = 75,
  OtherMedia = 76,
  GlobalPayments = 77,
  TradeDoubler = 78,
  GlobalPaymentsUK = 79,
  EnduranceZone = 80,
  EveryPay = 81,
  PayTech = 82,
  FormStack = 83,
  Eloqua = 84,
  SalesForce = 85,
  AFL = 86,
  NFL = 87,
  OpenConnect = 88,
  NBA = 89,
  BrainTree = 90,
  Playable = 91,
  TPF = 92,
  Braize = 93,
  FortressPaymentHub = 94,
  Adyen = 95,
  FortressFeedManager = 96,
  Strava = 97,
  Snapchat = 98,
  Attentive = 99,
  Clover = 100,
  GoAheadPay = 101,
  Azure = 102,
  WIT = 103,
  SportsIllustrated = 104,
  RAWEnginnering = 105,
  Yinzcam = 106,
  Maileon = 107,
  Peloton = 108,
  FusionAuth = 109,
  MyZoneFitness = 110,
  Everi = 111,
  Polar = 112,
  OuraRing = 113,
  Shopify = 114,
  Paze = 115,
  Apple = 116,
  Whoop = 117,
  FittestApp = 118,
  Olive = 119,
}

export enum InputType {
  Text = 1,
  Password = 2,
  Cookie = 3,
  QueryString = 4,
  Header = 5,
  Hidden = 6,
  Url = 7,
  RequestData = 8,
  Javascript = 9,
}
